(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-navigation"]) return;
  try {
    
  class ProductNavigation extends HTMLElement {
    constructor() {
      super();
      this.header = document.getElementById('shopify-section-header');
      this.linkContainer = this.querySelector('.product-navigation__links');
      this.headerBounds = {};
      this.parent = this.parentElement;
      this.section = this.parent.parentElement;
      this.container = this.section.parentElement;
      this.submitButton = this.container.querySelector('[type="submit"]');
      this.sections = this.container.querySelectorAll(`#${this.section.id} ~ .shopify-section`);
      this.sibling = this.sections[0];

      this.generateLinks();
      this.querySelectorAll('a:not(.button)').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));

      this.generateSelect();
      this.querySelector('select').addEventListener('change', this.onSelectChange.bind(this));

      if (this.parent?.dataset?.stickyHeader && window.outerWidth > 750) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }

      this.submitButton.addEventListener('click', this.onClickHandler.bind(this));
      document.addEventListener('loadingEvent', this.loadingHandler.bind(this));
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.section);
    }

    onScroll() {
      const scrollTop = window.pageYOffset - 40 || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.header.offsetHeight) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.offsetHeight) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= 0) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.section.classList.add('shopify-section-product-navigation-sticky');
      this.section.style.transform = 'translateY(0%)';
      this.sibling.style.paddingTop = `${this.section.offsetHeight}px`;
    }

    reveal() {
      this.section.classList.add('shopify-section-product-navigation-sticky', 'animate');
      this.section.style.transform = `translateY(${this.header.offsetHeight}px)`;
      this.sibling.style.paddingTop = `${this.section.offsetHeight}px`;
    }

    reset() {
      this.section.classList.remove('shopify-section-product-navigation-sticky', 'animate');
      this.section.style.transform = 'translateY(0)';
      this.sibling.style.paddingTop = 0;
    }

    generateLinks() {
      const links = [...this.sections]
        .map((section) =>
          section.querySelector('[data-product-navigation]')?.dataset?.productNavigation
            ? `<a href="#${section.id}">${
                section.querySelector('[data-product-navigation]')?.dataset?.productNavigation ? section.querySelector('[data-product-navigation]').dataset.productNavigation : null
              }</a>`
            : null
        )
        .join('');

      // Prepend the new links to the existing content, trimming any leading/trailing whitespace
      this.linkContainer.innerHTML = links + this.linkContainer.innerHTML.trim();
    }

    generateSelect() {
      const container = document.createElement('div');
      const wrapper = document.createElement('div');
      const arrow = document.createElement('span');

      container.className = 'product-navigation__select-container';
      wrapper.className = 'product-navigation__select-wrapper';
      arrow.className = 'product-navigation__select-arrow';

      const select = document.createElement('select');

      wrapper.appendChild(arrow);
      wrapper.appendChild(select);
      container.appendChild(wrapper);

      if (this.parent?.dataset?.mobileLinearGradient) {
        container.className += ' product-navigation__select-container--linear-gradient';
      }

      const links = [...this.sections]
        .map((section) => {
          const value = section.querySelector('[data-product-navigation]')?.dataset?.productNavigation
            ? section.querySelector('[data-product-navigation]').dataset.productNavigation
            : section.id.split('__')[1];
          return `<option value="#${section.id}">${value}</option>`;
        })
        .join('');

      select.innerHTML = links;

      this.linkContainer.appendChild(container);
    }

    onItemClick(event) {
      event.preventDefault();
      this.scrollTo(event.target.hash);
    }

    onSelectChange(event) {
      event.preventDefault();
      this.scrollTo(event.target.value);
    }

    onClickHandler() {
      const mainAddToCart = document.querySelector('product-form [type="submit"]');
      mainAddToCart.click();
    }

    loadingHandler(event) {
      if (event.detail) {
        this.submitButton.classList.add('loading');
        this.submitButton.setAttribute('aria-disabled', true);
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      } else {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      }
    }

    scrollTo(selector) {
      const destination = this.container.querySelector(selector);

      let position = destination.offsetTop;
      if (window.pageYOffset > position) {
        position -= this.offsetHeight + this.header.offsetHeight;
      } else {
        position -= this.offsetHeight;
      }
      window.scrollTo({ top: position, behavior: 'smooth' });
      destination.setAttribute('tabindex', '-1');
      destination.focus({ preventScroll: true });
    }
  }

  customElements.define('product-navigation', ProductNavigation);

  } catch(e) { console.error(e); }
})();
})();
